import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormLegacyHelper from "@Scripts/Infrastructure/FormLegacyHelper";

@Component({ name: "NewsletterSubscribe" })
export default class NewsletterSubscribe extends Vue {
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public isPrivacyPolicyShow: boolean = false;
    public privacyPolicy: string = null;
    public newsletterSubscribeSubmit: any = {};
    public validationErrors: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    get originPage() {
        return (<any>window).App.bag.OriginPage;
    }

    @Prop() readonly recaptchaSiteKey: string;

    public mounted() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", "https://www.google.com/recaptcha/api.js");
        document.head.appendChild(recaptchaScript);
    }

    public async showPrivacyPolicy() {
        this.isPrivacyPolicyShow = !this.isPrivacyPolicyShow;

        if (!this.privacyPolicy) {
            let response = await Axios.post(this.routes.Terms_GetPrivacyPolicy);

            this.privacyPolicy = Object.freeze(response.data.description);
        }
    }

    public async setNewsletterSubscribeSubmit() {
        this.validationErrors = [];
        this.isLoading = true;
        FormLegacyHelper.resetValidation();

        try {
            let response = (await Axios.post(this.routes.Newsletter_NewsletterSubscribe, { email: this.newsletterSubscribeSubmit.Email, isprivacypolicy: this.newsletterSubscribeSubmit.IsPrivacyPolicy }, { headers: { "RecaptchaVerificationToken": (<any>window).grecaptcha.getResponse() } })).data;

            this.isSuccess = true;
        } catch (error) {
            FormLegacyHelper.resetValidation();

            if (error.response) {
                if (error.response.status === 400) {
                    let validationState = error.response.data;
                    FormLegacyHelper.setValidation(validationState);

                    for (var propertyName in error.response.data) {
                        if (error.response.data.hasOwnProperty(propertyName)) {
                            for (let message of error.response.data[propertyName]) {
                                this.validationErrors.push({ message: message });
                            }
                        }
                    }
                }
            }
            this.isLoading = false;

            (<any>window).grecaptcha.reset();
        }
    }
};